import { styled } from 'styletron-react';
import { TechemTheme } from '@techem/techem-theme';

export const GreyLine = styled('div', {
  height: '1px',
  backgroundColor: TechemTheme.colors.backgroundSecondary
});
